import React, { FC } from 'react';

import router, { RouteItemType } from '~/core/router';
import LegalPage from '~/projects/polyllm-chat/components/LegalPage';
import {
  privacyPolicyMarkdown,
  subscriptionTermsMarkdown,
  termsOfUseMarkdown,
} from '~/projects/polyllm-chat/components/LegalPage/content';

const PrivacyPolicyPath = '/legal/privacy-policy';
const SubscriptionTermsPath = '/legal/subscription-terms';
const TermsOfUsePath = '/legal/terms-of-use';

const PrivacyPolicyPage: FC = () => (
  <LegalPage markdown={privacyPolicyMarkdown} />
);

const SubscriptionTermsPage: FC = () => (
  <LegalPage markdown={subscriptionTermsMarkdown} />
);

const TermsOfUsePage: FC = () => <LegalPage markdown={termsOfUseMarkdown} />;

const getPrivacyTitle = (): string => 'Privacy Policy';
const getSubscriptionTermsTitle = (): string => 'Subscription Terms';
const getTermsTitle = (): string => 'Terms of Use';

const LegalRoutes: RouteItemType[] = [
  {
    Component: PrivacyPolicyPage,
    path: PrivacyPolicyPath,
    getTitle: getPrivacyTitle,
  },
  {
    Component: SubscriptionTermsPage,
    path: SubscriptionTermsPath,
    getTitle: getSubscriptionTermsTitle,
  },
  {
    Component: TermsOfUsePage,
    path: TermsOfUsePath,
    getTitle: getTermsTitle,
  },
];

router.addUnAuthorizedRoutes(LegalRoutes);
